export const mapUiRole = (role) => {
 if (!role) return "User";

 // role may be string or object
 const roleName = (typeof role === "string" ? role : role.name || "").trim().toLowerCase();

 if (roleName === "admin") return "Admin";
 if (roleName === "po") return "PO";

 // Engineer, Manager, Viewer, etc.
 return "User";
};
